import desanitizeString from '../sanitizeUtil/sanitizeUtil';

const getLabels = (schema) => {
  const labels = schema.map((status) => desanitizeString(status.label));
  return labels;
};

export default getLabels;
